module.exports = __webpack_public_path__ + "static/media/homepage_atf_1_en.7803594a.png";